export interface VideoData {
  id: number;
  slug: string;
  title: string;
  category: string;
  categoryName: string;
  description: string;
  coverImage: string;
  rating: number;
  views: string;
  updateStatus: string;
  episodeCount: string;
  tags: string[];
  featured: boolean;
}

export const categories = [
  {
    slug: "dianshiju",
    name: "电视剧",
    icon: "ri-tv-line",
    description: "海量电视剧全集免费在线观看，高清不缓冲",
  },
  {
    slug: "dianying",
    name: "电影",
    icon: "ri-film-line",
    description: "最新热门电影一网打尽，畅快观影体验",
  },
  {
    slug: "zongyi",
    name: "综艺",
    icon: "ri-live-line",
    description: "热门综艺节目实时更新，精彩不断",
  },
  {
    slug: "dongman",
    name: "动漫",
    icon: "ri-ghost-smile-line",
    description: "日漫国漫全收录，动漫迷的天堂",
  },
  {
    slug: "jilupian",
    name: "纪录片",
    icon: "ri-earth-line",
    description: "BBC、Discovery高分纪录片合集",
  },
  {
    slug: "duanshipin",
    name: "短视频",
    icon: "ri-vidicon-line",
    description: "精彩短视频每日更新，碎片时间的最佳选择",
  },
];

export const videos: VideoData[] = [
  {
    id: 1,
    slug: "kuangbiao",
    title: "狂飙",
    category: "dianshiju",
    categoryName: "电视剧",
    description: "2023年现象级反黑刑侦剧，张译、张颂文主演。讲述了一线刑警安欣与黑恶势力长达二十年的生死搏斗，展现扫黑除恶斗争的艰难与决心。剧情紧凑，全员演技在线。",
    coverImage: "https://readdy.ai/api/search-image?query=A%20dramatic%20Chinese%20TV%20series%20poster%20for%20anti-corruption%20drama%20featuring%20two%20determined%20detectives%20in%20dark%20urban%20night%20scene%20with%20neon%20lights%20reflecting%20on%20wet%20streets%2C%20cinematic%20composition%20with%20warm%20amber%20and%20cool%20blue%20tones%2C%20film%20grain%20texture%2C%20high%20contrast%20noir%20lighting%2C%20poster%20design%20with%20bold%20Chinese%20calligraphy%20title%2C%20editorial%20photography%20style&width=640&height=400&seq=video-cover-01&orientation=landscape",
    rating: 9.1,
    views: "2.3亿",
    updateStatus: "已完结",
    episodeCount: "39集全",
    tags: ["刑侦", "反黑", "悬疑", "高分"],
    featured: true,
  },
  {
    id: 2,
    slug: "liulangdiqiu2",
    title: "流浪地球2",
    category: "dianying",
    categoryName: "电影",
    description: "中国科幻电影巅峰之作续集，吴京、刘德华主演。故事围绕太阳危机背景下人类为生存而展开的宏大计划，视觉特效震撼，情感饱满动人。",
    coverImage: "https://readdy.ai/api/search-image?query=Epic%20sci-fi%20movie%20poster%20showing%20massive%20planetary%20engines%20firing%20against%20dark%20space%20backdrop%20with%20Earth%20visible%2C%20dramatic%20orange%20and%20blue%20color%20palette%2C%20futuristic%20spacesuit%20design%2C%20grand%20scale%20cinematic%20composition%2C%20high-end%20visual%20effects%20style%20poster%20with%20Chinese%20title%20typography%2C%20film%20grain%20texture&width=640&height=400&seq=video-cover-02&orientation=landscape",
    rating: 8.3,
    views: "1.8亿",
    updateStatus: "HD高清",
    episodeCount: "173分钟",
    tags: ["科幻", "灾难", "国产", "IMAX"],
    featured: true,
  },
  {
    id: 3,
    slug: "chenghuanji",
    title: "承欢记",
    category: "dianshiju",
    categoryName: "电视剧",
    description: "杨紫、许凯主演的都市情感剧，讲述麦承欢在家庭与自我之间的成长蜕变。温暖治愈，真实展现当代年轻人的生活困境与爱情选择。",
    coverImage: "https://readdy.ai/api/search-image?query=Warm%20romantic%20Chinese%20TV%20drama%20poster%20featuring%20a%20young%20couple%20in%20modern%20Shanghai%20cityscape%20at%20sunset%2C%20soft%20golden%20hour%20lighting%2C%20cozy%20urban%20aesthetic%20with%20warm%20beige%20and%20soft%20pink%20tones%2C%20contemporary%20fashion%20styling%2C%20editorial%20romantic%20drama%20poster%20with%20elegant%20Chinese%20typography%2C%20clean%20composition&width=640&height=400&seq=video-cover-03&orientation=landscape",
    rating: 8.6,
    views: "1.5亿",
    updateStatus: "更新至28集",
    episodeCount: "共36集",
    tags: ["都市", "情感", "成长", "治愈"],
    featured: false,
  },
  {
    id: 4,
    slug: "manjianghong",
    title: "满江红",
    category: "dianying",
    categoryName: "电影",
    description: "张艺谋执导古装悬疑喜剧，沈腾、易烊千玺主演。南宋年间，一场围绕秦桧的惊天迷局在宰相府内展开，层层反转，笑中带泪。",
    coverImage: "https://readdy.ai/api/search-image?query=Historical%20Chinese%20mystery%20film%20poster%20set%20in%20ancient%20Song%20dynasty%20courtyard%20with%20deep%20red%20lanterns%20and%20dark%20wooden%20architecture%2C%20dramatic%20shadows%20and%20warm%20torchlight%2C%20traditional%20Chinese%20costume%20design%2C%20suspenseful%20composition%20with%20hidden%20figures%20in%20corridors%2C%20wuxia%20film%20aesthetic%20with%20bold%20red%20and%20black%20color%20scheme%2C%20Chinese%20calligraphy%20title&width=640&height=400&seq=video-cover-04&orientation=landscape",
    rating: 7.4,
    views: "2.1亿",
    updateStatus: "HD高清",
    episodeCount: "159分钟",
    tags: ["古装", "悬疑", "喜剧", "张艺谋"],
    featured: true,
  },
  {
    id: 5,
    slug: "benpaoba-xiongdi",
    title: "奔跑吧·生态篇",
    category: "zongyi",
    categoryName: "综艺",
    description: "国民综艺《奔跑吧》全新生态篇，李晨、郑恺、白鹿等常驻MC携手飞行嘉宾，在祖国大好河山中展开趣味挑战，传递环保理念。",
    coverImage: "https://readdy.ai/api/search-image?query=Vibrant%20Chinese%20variety%20show%20poster%20with%20energetic%20cast%20running%20through%20lush%20green%20mountain%20landscape%2C%20bright%20natural%20sunlight%2C%20joyful%20expressions%2C%20outdoor%20adventure%20aesthetic%20with%20fresh%20green%20and%20sky%20blue%20tones%2C%20dynamic%20action%20composition%2C%20fun%20and%20youthful%20poster%20design%20with%20colorful%20Chinese%20typography&width=640&height=400&seq=video-cover-05&orientation=landscape",
    rating: 7.8,
    views: "9,800万",
    updateStatus: "更新至10期",
    episodeCount: "共12期",
    tags: ["户外", "竞技", "真人秀", "环保"],
    featured: false,
  },
  {
    id: 6,
    slug: "lingshi-bairen",
    title: "灵笼·终章",
    category: "dongman",
    categoryName: "动漫",
    description: "国产3D动画巅峰之作终章篇，在未来末日世界，人类在悬浮堡垒灯塔城中为生存而战。极致画质，深刻剧情，国漫里程碑作品。",
    coverImage: "https://readdy.ai/api/search-image?query=Dark%20sci-fi%20Chinese%203D%20animation%20poster%20showing%20futuristic%20floating%20fortress%20city%20against%20apocalyptic%20orange%20sky%2C%20mechanical%20exoskeleton%20warriors%20in%20combat%20stance%2C%20post-apocalyptic%20wasteland%20aesthetic%20with%20dark%20industrial%20tones%20and%20glowing%20energy%20effects%2C%20cinematic%20anime%20style%20with%20dramatic%20composition%2C%20bold%20Chinese%20and%20English%20typography&width=640&height=400&seq=video-cover-06&orientation=landscape",
    rating: 9.3,
    views: "1.2亿",
    updateStatus: "更新至6集",
    episodeCount: "共12集",
    tags: ["科幻", "3D", "国漫", "末日"],
    featured: true,
  },
  {
    id: 7,
    slug: "diqiuyumai",
    title: "地球脉动·第三季",
    category: "jilupian",
    categoryName: "纪录片",
    description: "BBC史诗级自然纪录片第三季，大卫·爱登堡爵士解说。用8K超高清镜头捕捉地球上最震撼的生命故事，从深海到极地，每一帧都是壁纸。",
    coverImage: "https://readdy.ai/api/search-image?query=Breathtaking%20BBC%20nature%20documentary%20poster%20showing%20diverse%20wildlife%20in%20their%20natural%20habitats%20from%20deep%20ocean%20to%20arctic%20ice%2C%20stunning%20high%20quality%20photography%2C%20rich%20vibrant%20natural%20colors%20with%20dramatic%20lighting%2C%20majestic%20landscape%20composition%2C%20David%20Attenborough%20series%20aesthetic%20with%20elegant%20typography%20over%20pristine%20nature%20scene&width=640&height=400&seq=video-cover-07&orientation=landscape",
    rating: 9.8,
    views: "6,500万",
    updateStatus: "已完结",
    episodeCount: "共8集",
    tags: ["自然", "BBC", "4K", "经典"],
    featured: false,
  },
  {
    id: 8,
    slug: "fanhua",
    title: "繁花",
    category: "dianshiju",
    categoryName: "电视剧",
    description: "王家卫首次执导电视剧，胡歌、马伊琍、唐嫣主演。以上世纪九十年代上海为背景，讲述阿宝在商海沉浮中的传奇人生，光影美学极致。",
    coverImage: "https://readdy.ai/api/search-image?query=Wong%20Kar-wai%20style%20Chinese%20TV%20drama%20poster%20set%20in%201990s%20Shanghai%20with%20neon%20signs%20and%20rainy%20streets%2C%20nostalgic%20golden%20lighting%20with%20deep%20green%20and%20burgundy%20tones%2C%20vintage%20fashion%20from%20reform%20era%2C%20cinematic%20composition%20with%20soft%20focus%20and%20bokeh%20effects%2C%20art%20film%20aesthetic%20poster%20with%20elegant%20Chinese%20calligraphy%20title%2C%20dreamy%20atmospheric%20mood&width=640&height=400&seq=video-cover-08&orientation=landscape",
    rating: 8.9,
    views: "1.6亿",
    updateStatus: "已完结",
    episodeCount: "共30集",
    tags: ["年代", "商战", "王家卫", "经典"],
    featured: true,
  },
  {
    id: 9,
    slug: "xiaoaojianghu",
    title: "笑傲江湖",
    category: "dianying",
    categoryName: "电影",
    description: "经典武侠改编电影，徐克执导。令狐冲的江湖传奇，快意恩仇的武侠世界。华丽的动作设计和深刻的侠义精神，武侠电影的巅峰之作。",
    coverImage: "https://readdy.ai/api/search-image?query=Classic%20Chinese%20wuxia%20film%20poster%20featuring%20a%20lone%20swordsman%20in%20flowing%20white%20robes%20standing%20on%20misty%20mountain%20peak%20with%20dramatic%20sunset%20sky%2C%20traditional%20Chinese%20ink%20painting%20aesthetic%20with%20bold%20red%20accents%2C%20dynamic%20martial%20arts%20pose%2C%20epic%20cinematic%20composition%20with%20calligraphy%20brush%20strokes%2C%20classic%20Hong%20Kong%20cinema%20poster%20style%20with%20gold%20Chinese%20typography&width=640&height=400&seq=video-cover-09&orientation=landscape",
    rating: 8.5,
    views: "8,200万",
    updateStatus: "HD修复版",
    episodeCount: "118分钟",
    tags: ["武侠", "经典", "金庸", "徐克"],
    featured: false,
  },
  {
    id: 10,
    slug: "xiangbanxinchuan",
    title: "向往的生活·第七季",
    category: "zongyi",
    categoryName: "综艺",
    description: "慢综艺标杆《向往的生活》第七季收官之作，黄磊、何炅领衔。在森林小屋中接待老友，享受田园生活，传递简单生活的美好。",
    coverImage: "https://readdy.ai/api/search-image?query=Cozy%20Chinese%20slow-living%20variety%20show%20poster%20showing%20warm%20wooden%20countryside%20cabin%20surrounded%20by%20lush%20green%20forest%20and%20vegetable%20garden%2C%20soft%20morning%20sunlight%20filtering%20through%20trees%2C%20rustic%20lifestyle%20aesthetic%20with%20warm%20earth%20tones%20and%20natural%20greens%2C%20peaceful%20and%20inviting%20composition%2C%20handmade%20craft%20style%20poster%20with%20gentle%20Chinese%20calligraphy&width=640&height=400&seq=video-cover-10&orientation=landscape",
    rating: 8.2,
    views: "7,600万",
    updateStatus: "更新至8期",
    episodeCount: "共14期",
    tags: ["慢综艺", "生活", "田园", "温馨"],
    featured: false,
  },
  {
    id: 11,
    slug: "canlangbener",
    title: "苍兰诀",
    category: "dongman",
    categoryName: "动漫",
    description: "改编自九鹭非香同名小说的仙侠动画，讲述小兰花与东方青苍跨越种族的爱恋。唯美画风，虐心剧情，年度最强国漫之一。",
    coverImage: "https://readdy.ai/api/search-image?query=Ethereal%20Chinese%20xianxia%20animation%20poster%20featuring%20celestial%20beings%20in%20flowing%20ancient%20robes%20floating%20among%20cherry%20blossom%20clouds%20with%20magical%20glowing%20butterflies%2C%20dreamy%20purple%20and%20pink%20color%20palette%2C%20traditional%20Chinese%20palace%20architecture%20in%20background%2C%20romantic%20fantasy%20aesthetic%20with%20soft%20luminous%20effects%2C%20beautiful%20anime%20art%20style%20poster%20with%20elegant%20Chinese%20calligraphy&width=640&height=400&seq=video-cover-11&orientation=landscape",
    rating: 8.8,
    views: "9,200万",
    updateStatus: "已完结",
    episodeCount: "共36集",
    tags: ["仙侠", "恋爱", "国漫", "唯美"],
    featured: false,
  },
  {
    id: 12,
    slug: "heibanbaodong",
    title: "核弹爆炸·人类末日",
    category: "jilupian",
    categoryName: "纪录片",
    description: "探索频道出品的深度纪录片，还原核武器研发历史与真实威力。通过解密档案和CG还原技术，揭示人类面临的最大威胁。震撼人心。",
    coverImage: "https://readdy.ai/api/search-image?query=Intense%20Discovery%20Channel%20documentary%20poster%20about%20nuclear%20weapons%20showing%20dramatic%20mushroom%20cloud%20silhouette%20against%20apocalyptic%20red%20sky%2C%20stark%20contrast%20black%20and%20red%20color%20scheme%2C%20declassified%20document%20texture%20overlay%2C%20sober%20and%20powerful%20composition%20with%20minimalist%20design%2C%20serious%20documentary%20aesthetic%20with%20clean%20typography%2C%20thought-provoking%20and%20impactful%20visual&width=640&height=400&seq=video-cover-12&orientation=landscape",
    rating: 9.0,
    views: "5,400万",
    updateStatus: "HD高清",
    episodeCount: "共3集",
    tags: ["军事", "历史", "科普", "探索"],
    featured: false,
  },
  {
    id: 13,
    slug: "qingyunian2",
    title: "庆余年·第二季",
    category: "dianshiju",
    categoryName: "电视剧",
    description: "万众期待的古装权谋巨制第二季，张若昀、李沁回归。范闲在京都的权力漩涡中继续他的传奇旅程，阴谋与热血交织。",
    coverImage: "https://readdy.ai/api/search-image?query=Grand%20Chinese%20historical%20drama%20poster%20featuring%20a%20young%20scholar-warrior%20in%20elaborate%20ancient%20Han%20dynasty%20costume%20standing%20before%20imperial%20palace%20gates%2C%20dramatic%20golden%20hour%20lighting%20with%20rich%20amber%20and%20deep%20red%20tones%2C%20power%20and%20intrigue%20atmosphere%2C%20epic%20widescreen%20composition%20with%20silhouetted%20figures%2C%20premium%20period%20drama%20poster%20with%20bold%20Chinese%20calligraphy%20title&width=640&height=400&seq=video-cover-13&orientation=landscape",
    rating: 8.4,
    views: "2.7亿",
    updateStatus: "已完结",
    episodeCount: "共36集",
    tags: ["古装", "权谋", "改编", "热剧"],
    featured: true,
  },
  {
    id: 14,
    slug: "dahua-chongqi",
    title: "大话西游·重启",
    category: "dianying",
    categoryName: "电影",
    description: "经典IP全新演绎，融合现代特效技术与经典故事内核。至尊宝与紫霞仙子的爱情故事以全新视角呈现，致敬经典又有所突破。",
    coverImage: "https://readdy.ai/api/search-image?query=Fantasy%20comedy%20Chinese%20film%20poster%20featuring%20a%20playful%20Monkey%20King%20character%20wielding%20magical%20staff%20against%20colorful%20sunset%20clouds%2C%20whimsical%20and%20romantic%20atmosphere%20with%20warm%20golden%20and%20pink%20hues%2C%20traditional%20Chinese%20mythology%20meets%20modern%20visual%20effects%2C%20dynamic%20and%20fun%20composition%2C%20nostalgic%20yet%20fresh%20movie%20poster%20with%20artistic%20Chinese%20calligraphy%20title&width=640&height=400&seq=video-cover-14&orientation=landscape",
    rating: 7.2,
    views: "1.3亿",
    updateStatus: "HD高清",
    episodeCount: "135分钟",
    tags: ["奇幻", "喜剧", "爱情", "经典"],
    featured: false,
  },
  {
    id: 15,
    slug: "jietouliana",
    title: "街头篮球·热血篇",
    category: "dongman",
    categoryName: "动漫",
    description: "热血体育动漫新作，讲述一群街头少年追逐篮球梦想的故事。流畅的动作分镜，燃炸的比赛场面，献给每一个热爱篮球的你。",
    coverImage: "https://readdy.ai/api/search-image?query=Dynamic%20sports%20anime%20poster%20featuring%20young%20basketball%20players%20performing%20an%20epic%20dunk%20on%20urban%20outdoor%20court%20at%20sunset%2C%20dramatic%20orange%20sky%20with%20motion%20blur%20effects%2C%20sweat%20and%20energy%20visible%2C%20graffiti%20wall%20background%2C%20hot-blooded%20shonen%20anime%20style%20with%20bold%20action%20lines%2C%20vibrant%20warm%20color%20palette%2C%20energetic%20Japanese%20anime%20poster%20design%20with%20stylized%20typography&width=640&height=400&seq=video-cover-15&orientation=landscape",
    rating: 8.1,
    views: "4,800万",
    updateStatus: "更新至18集",
    episodeCount: "共24集",
    tags: ["体育", "热血", "篮球", "青春"],
    featured: false,
  },
  {
    id: 16,
    slug: "zhongguomeishi",
    title: "舌尖上的中国·第四季",
    category: "jilupian",
    categoryName: "纪录片",
    description: "中国美食纪录片标杆系列第四季回归，探寻神州大地最具代表性的风味人间。从街头小吃到国宴大菜，每一帧都让人垂涎欲滴。",
    coverImage: "https://readdy.ai/api/search-image?query=Mouthwatering%20Chinese%20food%20documentary%20poster%20showing%20steaming%20hot%20traditional%20dishes%20arranged%20on%20rustic%20wooden%20table%2C%20dramatic%20spotlight%20lighting%20on%20food%20with%20dark%20atmospheric%20background%2C%20rich%20warm%20amber%20and%20deep%20red%20tones%2C%20steam%20and%20smoke%20effects%2C%20premium%20culinary%20photography%20style%2C%20elegant%20Chinese%20calligraphy%20title%20with%20food%20garnish%20decorative%20elements&width=640&height=400&seq=video-cover-16&orientation=landscape",
    rating: 9.5,
    views: "8,900万",
    updateStatus: "更新至5集",
    episodeCount: "共8集",
    tags: ["美食", "文化", "中国", "高分"],
    featured: true,
  },
  {
    id: 17,
    slug: "langyabang3",
    title: "琅琊榜·第三季",
    category: "dianshiju",
    categoryName: "电视剧",
    description: "延续琅琊榜系列经典的权谋古装大剧，全新人物、全新故事。朝堂之上的智谋较量与江湖之中的快意恩仇，再续经典传奇。",
    coverImage: "https://readdy.ai/api/search-image?query=Elegant%20Chinese%20historical%20political%20drama%20poster%20showing%20a%20strategist%20in%20flowing%20white%20hanfu%20robes%20standing%20in%20bamboo%20forest%20with%20misty%20mountains%20background%2C%20ink%20wash%20painting%20aesthetic%20with%20subtle%20gold%20accents%2C%20contemplative%20and%20powerful%20atmosphere%2C%20sophisticated%20widescreen%20composition%20with%20traditional%20Chinese%20art%20influences%2C%20premium%20drama%20poster%20with%20refined%20calligraphy%20title&width=640&height=400&seq=video-cover-17&orientation=landscape",
    rating: 8.7,
    views: "1.9亿",
    updateStatus: "更新至22集",
    episodeCount: "共40集",
    tags: ["古装", "权谋", "经典", "续作"],
    featured: true,
  },
  {
    id: 18,
    slug: "jiayouxiaokeai",
    title: "加油！小可爱",
    category: "zongyi",
    categoryName: "综艺",
    description: "萌娃成长观察类综艺，记录一群可爱的小朋友在幼儿园中的日常生活。纯真笑容治愈人心，让观众找回童年的美好回忆。",
    coverImage: "https://readdy.ai/api/search-image?query=Adorable%20Chinese%20kids%20reality%20show%20poster%20showing%20happy%20preschool%20children%20playing%20in%20colorful%20classroom%20with%20soft%20natural%20light%20through%20windows%2C%20bright%20and%20cheerful%20pastel%20color%20palette%20with%20warm%20yellow%20and%20soft%20pink%20tones%2C%20genuine%20joyful%20expressions%2C%20cute%20and%20heartwarming%20aesthetic%20with%20playful%20composition%2C%20family-friendly%20variety%20show%20poster%20with%20fun%20rounded%20Chinese%20typography&width=640&height=400&seq=video-cover-18&orientation=landscape",
    rating: 8.0,
    views: "3,200万",
    updateStatus: "更新至15期",
    episodeCount: "共20期",
    tags: ["萌娃", "成长", "治愈", "亲子"],
    featured: false,
  },
];

export const featuredVideos = videos.filter((v) => v.featured);

export const latestVideos = [...videos].sort(() => Math.random() - 0.5).slice(0, 8);

export const getVideoBySlug = (slug: string) => videos.find((v) => v.slug === slug);

export const getVideosByCategory = (categorySlug: string) =>
  videos.filter((v) => v.category === categorySlug);

export const getRelatedVideos = (currentSlug: string, category: string, limit: number = 4) =>
  videos.filter((v) => v.category === category && v.slug !== currentSlug).slice(0, limit);

export const getCategoryBySlug = (slug: string) =>
  categories.find((c) => c.slug === slug);